module.exports = __webpack_public_path__ + "1c2060c472005d747616ba0180184317.MP3";